import React from 'react';

const Changeyear = () => {
  const currentYear = new Date().getFullYear();

  return (
      <div className="copy-right pt-2">
        © {currentYear} SISOLIONLINE SERVICES LLP (GadgetZippy), All rights reserved
        {/* © 2020 GadgetZippy, All rights reserved – Technology Powered By <a href="https://axlrdata.com/" target="_blank" className="blue-color-h">Axlr Data</a> */}
      </div>
  );
};

export default Changeyear;
